import { NodeIds } from '.';

const ChildNodeIds = {
    [NodeIds.GeneralInformation]: {
        ContractRenewal: 'ContractRenewal'
    }
} as const;

export default ChildNodeIds;
